import { create } from 'zustand';

export const useCountStore = create(set => ({
  count: {
    v_submit: 0,
    v_review: 0,
    v_pending: 0,
    i_submit: 0,
    i_review: 0,
    i_pending: 0,
  },
  setCounts: (key, value) => set(state => ({ count: { ...state.count, [key]: value } })),
}));

export const useUserJudge = create(set => ({
  judge: {
    selected: 'video',
    video: '',
    image: '',
  },
  setJudge: (key, value) => set(state => ({ judge: { ...state.judge, [key]: value } })),
}));
